"use client";

import { ComparisonTable } from "@/components/compare/comparison-table";

export function ComparisonLiteLLM() {
	return <ComparisonTable competitor="litellm" />;
}
